import React, { useState } from 'react';

const ServiceSelection = ({ onServiceSelect }) => {
  const [selectedServices, setSelectedServices] = useState([]);

  const handleServiceButtonClick = (serviceName) => {
    
    if (selectedServices.includes(serviceName)) {
     
      setSelectedServices((prevSelectedServices) =>
        prevSelectedServices.filter((service) => service !== serviceName)
      );
    } else {
     
      setSelectedServices((prevSelectedServices) => [...prevSelectedServices, serviceName]);
    }
  };

  
  React.useEffect(() => {
    onServiceSelect(selectedServices);
  }, [selectedServices, onServiceSelect]);

  return (
    <div className="container mt-8">
      <h1 className="text-2xl font-bold text-orange-default">SERVICES</h1>
      <p className="text-md font-semibold text-gray-300">Select the desired services</p>
      <div className="grid grid-cols-3 w-12/12 gap-4 mt-4 mb-10">
        <button
          className={`px-1 py-2 rounded-md text-white font-medium ${
            selectedServices.includes('UI/UX Design') ? 'bg-orange-default' : 'bg-gray-900'
          }`}
          onClick={() => handleServiceButtonClick('UI/UX Design')}
        >
          UI/UX Design
        </button>
        <button
          className={`px-1 py-2 rounded-md text-white font-medium ${
            selectedServices.includes('Frontend Dev.') ? 'bg-orange-default' : 'bg-gray-900'
          }`}
          onClick={() => handleServiceButtonClick('Frontend Dev.')}
        >
          Frontend Dev.
        </button>
        <button
          className={`px-1 py-2 rounded-md text-white font-medium ${
            selectedServices.includes('Backend Dev.') ? 'bg-orange-default' : 'bg-gray-900'
          }`}
          onClick={() => handleServiceButtonClick('Backend Dev.')}
        >
          Backend Dev.
        </button>
      </div>
    </div>
  );
};

export default ServiceSelection;
